import GeometryAlgorithm from '../geometry/GeometryAlgorithm';
import Controller from '../components/Controller';
import Feedback from '../feedback/Feedback';

/**
 * 捕捉控制器类，用于管理所有的捕捉行为.
 */
export default class SnapController extends Controller {
    /**
     * 捕捉控制器类初始化方法.
     * @param {undefined} options - 没有接收参数
     * @returns {undefined}
     */
    constructor(options) {
        super(options);

        this.geometryAlgorithm = GeometryAlgorithm.getInstance();

        /**
         * 当前捕捉对象对应的捕捉行为对象
         * @type {object|null}
         */
        this.activeActor = null;
    }

    /**
     * 将组件添加到地图对象中
     * @param {object} map map对象
     * @returns {undefined}
     */
    onAdd(map) {
        super.onAdd(map);

        // 初始化反馈绘制相关的属性
        if (map.FeedbackController) {
            this._feedbackController = map.FeedbackController;
            this._feedback = new Feedback({ priority: 999 });
            this._feedbackController.add(this._feedback);
        }
        if (map.GeojsonConverter) {
            this._geojsonConverter = this._map.GeojsonConverter;
        }
    }

    onRemove() {
        this._feedbackController.delete(this._feedback);
        this._feedback = null;
        this._geojsonConverter = null;

        super.onRemove();
    }

    /**
     * 向捕捉控制器的捕捉行为容器中添加新的捕捉行为对象.
     * @param {Object} snapActor - 捕捉行为对象
     * @return {undefined}
     */
    add(snapActor) {
        super.add(snapActor);

        this.elements.sort((a, b) => b.options.priority - a.options.priority);
    }

    /**
     * 从捕捉控制器的捕捉行为容器中删清除所有的的捕捉行为对象
     * 并更新捕捉反馈.
     * @return {undefined}
     */
    clear() {
        this.activeActor = null;

        super.clear();

        this.refreshFeedback();
    }

    mouseSnap(mouseEvent) {
        const point = this._geojsonConverter.wrapLatLng(mouseEvent.latlng);

        return this.snap(point);
    }

    /**
     * 捕捉方法
     * @param {object<geojson>} point 点经纬度几何，一般是鼠标的位置
     * @returns {object} snapResult - 捕捉结果
     */
    snap(point) {
        if (this.elements.length === 0) {
            return null;
        }

        if (this.activeActor) {
            this.activeActor = null;
        }

        let snapResult = null;
        let minDis = Number.MAX_VALUE;
        const pointPixel = this._geojsonConverter.toPoint(point);
        for (let i = 0; i < this.elements.length; ++i) {
            const snapActor = this.elements[i];
            if (snapActor.enabled()) {
                if (this.activeActor && snapActor.options.priority < this.activeActor.options.priority) {
                    continue;
                }
                const tmpSnapResult = snapActor.snap(point);
                if (!tmpSnapResult) {
                    continue;
                }

                const snapPixel = this._geojsonConverter.toPoint(tmpSnapResult.point);
                const dis = pointPixel.distanceTo(snapPixel);
                if (dis < minDis) {
                    this.activeActor = snapActor;
                    snapResult = tmpSnapResult;
                    minDis = dis;
                }
            }
        }

        // 绘制捕捉效果
        this.refreshFeedback();

        return snapResult;
    }

    /**
     * 刷新捕捉的反馈渲染
     */
    refreshFeedback() {
        this._feedback.clear();
        if (this.activeActor && this._feedback) {
            this._feedback.addItems(this.activeActor.getDrawItems());
        }
        this._feedbackController.refresh();
    }
}
